import { useMutation } from '@tanstack/react-query';

import type { UpdateEmployeeSynchronizationArgs } from '../../../Domain/Employees/Services/EmployeeService';
import { employeeService } from '../../../Domain/Employees/Services/EmployeeService';

const mutationFn = (data: UpdateEmployeeSynchronizationArgs) => {
  return employeeService.updateEmployeeSynchronization(data);
};

export const useUpdateEmployeeSynchronization = () => {
  return useMutation<unknown, unknown, UpdateEmployeeSynchronizationArgs>(mutationFn);
};
